/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import {
  MOBILE_POS_ORDER_TYPE_OPTIONS,
  type MobilePosOrderType,
} from "../../../../shared/mobilePosOrderTypes";

export const MobilePosSettingsCard = defineComponent<{
  orderTypes: MobilePosOrderType[];
  onUpdateOrderTypes: (orderTypes: MobilePosOrderType[]) => void;
}>({
  name: "MobilePosSettingsCard",
  props: ["orderTypes", "onUpdateOrderTypes"],
  setup(props) {
    const { t } = useLocalization();

    const toggleOrderType = (orderType: MobilePosOrderType) => {
      const current = props.orderTypes;
      const next = current.includes(orderType)
        ? current.filter((value) => value !== orderType)
        : [...current, orderType];

      if (next.length > 0) props.onUpdateOrderTypes(next);
    };

    return () => {
      return (
        <div class="l-box-shadow rounded rounded-2xl shadow-xl bg-base-100 border border-base-100">
          <div class="card-body">
            <div class="flex items-center gap-3 mb-6">
              <div class="p-3 bg-info/10 rounded-xl">
                <span class="material-symbols-outlined text-info text-2xl">
                  smartphone
                </span>
              </div>
              <div class="flex-1">
                <h3 class="text-lg font-semibold text-accent">
                  {t("settings.config.mobile_pos")}
                </h3>
                <p class="text-sm text-base-content">
                  {t("settings.config.mobile_pos_desc")}
                </p>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              {MOBILE_POS_ORDER_TYPE_OPTIONS.map((type) => {
                const enabled = props.orderTypes.includes(type.value);

                return (
                  <div class="form-control">
                    <label class="cursor-pointer">
                      <div class="flex items-center justify-between p-4 border-2  rounded-xl hover:border-primary transition-all">
                        <div class="flex items-center gap-3">
                          <span class="material-symbols-outlined text-2xl text-base-content/70">
                            {type.icon}
                          </span>
                          <span class="label-text font-semibold text-base">
                            {t(type.labelKey)}
                          </span>
                        </div>
                        <input
                          type="checkbox"
                          checked={enabled}
                          class="toggle toggle-primary"
                          onChange={() => toggleOrderType(type.value)}
                        />
                      </div>
                    </label>
                  </div>
                );
              })}
            </div>
            <p class="text-xs text-base-content/50 mt-2">
              {t("settings.config.mobile_pos_order_types_hint")}
            </p>
          </div>
        </div>
      );
    };
  },
});
